let _ = t => t,
  _t,
  _t2,
  _t3,
  _t4;
import { memo, useContext } from 'react';
import { MediaPlaybackControlsContext } from '../../context/MediaPlaybackControlsContext';
import styledWithTheme from 'foundations-theming/utils';
import { MEDIA_PLAYER_COLORS } from '../../constants/Colors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ARROW_SIZE = 6;
const StyledDragLine = styledWithTheme.div(_t || (_t = _`
  position: absolute;
  top: 0;
  right: -${0}px;
  height: 100%;
  width: 7px;
  padding: 0 ${0}px;
  cursor: pointer;
  user-select: none;
  z-index: 2;
  transition: opacity 500ms;
  opacity: ${0};
  &:hover {
    background: rgba(0, 0, 0, 0.1);
  }
`), ARROW_SIZE / 2, ARROW_SIZE / 2, props => props.hasNoDuration || !props.visible ? 0 : 1);
const StyledDragLine_ArrowDown = styledWithTheme.div(_t2 || (_t2 = _`
  position: absolute;
  height: 0;
  width: 0;
  top: 0;
  left: -${0}px;

  border: ${0}px solid transparent;
  border-bottom-width: 0;
  border-top-color: ${0};
`), ARROW_SIZE / 2, ARROW_SIZE, ({
  theme
}) => theme.color[MEDIA_PLAYER_COLORS.ACTIVE_STATUS_FILL]);
const StyledDragLine_PlayLine = styledWithTheme.div(_t3 || (_t3 = _`
  left: ${0}px;
  position: absolute;
  height: 100%;
  width: 1px;
  background: ${0};
`), ARROW_SIZE / 2, ({
  theme
}) => theme.color[MEDIA_PLAYER_COLORS.ACTIVE_STATUS_FILL]);
const StyledDragLine_ArrowUp = styledWithTheme.div(_t4 || (_t4 = _`
  position: absolute;
  height: 0;
  width: 0;
  left: -${0}px;
  top: calc(100% - ${0}px);

  border: ${0}px solid transparent;
  border-top-width: 0;
  border-bottom-color: ${0};
`), ARROW_SIZE / 2, ARROW_SIZE, ARROW_SIZE, ({
  theme
}) => theme.color[MEDIA_PLAYER_COLORS.ACTIVE_STATUS_FILL]);
const MediaPlayerHead = ({
  visible
}) => {
  const {
    preciseDuration
  } = useContext(MediaPlaybackControlsContext);
  return /*#__PURE__*/_jsxs(StyledDragLine, {
    hasNoDuration: preciseDuration === 0,
    visible: visible,
    "data-test-id": "mediaTimeline-mediaPlayerHead",
    children: [/*#__PURE__*/_jsx(StyledDragLine_ArrowDown, {}), /*#__PURE__*/_jsx(StyledDragLine_PlayLine, {}), /*#__PURE__*/_jsx(StyledDragLine_ArrowUp, {})]
  });
};
export default /*#__PURE__*/memo(MediaPlayerHead);